import React, { useState } from "react";
import "../assets/css/style.css";
import "../assets/css/bootstrap/bootstrap.min.css";
import "../assets/css/font-awesome/all.min.css";
import "../assets/css/flaticon/flaticon.css";
import "../assets/css/owl-carousel/owl.carousel.min.css";
import "../assets/css/magnific-popup/magnific-popup.css";
// import "../assets/css/style.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [projectsDropdownOpen, setProjectsDropdownOpen] = useState(false);
  const [mobileProjectsDropdownOpen, setMobileProjectsDropdownOpen] = useState(false);

  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg bg-white shadow-lg fixed-top py-4">
        <div className="container-fluid d-flex align-items-center">
          <a className="navbar-brand me-4 d-flex align-items-center" href="/">
            <img
              src="logo.png"
              alt="Devi Vinayaka Builders Logo"
              style={{ height: "72px", borderRadius: "10px" }}
            />
          </a>

          {/* Hamburger Button for Mobile */}
          <button
            className="navbar-toggler d-block d-lg-none border-0 shadow-none p-0"
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
            style={{ background: "none", outline: "none" }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Desktop Menu */}
          <div className="collapse navbar-collapse d-none d-lg-block">
            <ul className="navbar-nav mx-auto d-flex gap-4">
              <li className="nav-item">
                <a className="nav-link fs-5" href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link fs-5" href="/About">About</a>
              </li>
              <li
                className="nav-item"
                onMouseEnter={() => setProjectsDropdownOpen(true)}
                onMouseLeave={() => setProjectsDropdownOpen(false)}
                style={{ position: "relative" }}
              >
                <a
                  className="nav-link fs-5 d-flex align-items-center gap-1"
                  href="/Projects"
                  role="button"
                  aria-expanded={projectsDropdownOpen}
                >
                  Projects
                  <span style={{ fontSize: "0.8rem" }}>&#9662;</span>
                </a>
                {projectsDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      minWidth: "210px",
                      background: "#ffffff",
                      boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                      zIndex: "99999",
                      marginTop: "0px",
                      borderTop: "3px solid #b8860b",
                    }}
                  >
                    <a
                      href="/CompletedProjects"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "14px 20px",
                        textDecoration: "none",
                        color: "#1a1a1a",
                        fontSize: "0.95rem",
                        fontWeight: "600",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#faf6ec";
                        e.currentTarget.style.color = "#b8860b";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.color = "#1a1a1a";
                      }}
                    >
                      <i className="fas fa-check-circle" style={{ color: "#28a745", fontSize: "1rem" }}></i>
                      <span>Completed Projects</span>
                    </a>
                  </div>
                )}
              </li>
              <li className="nav-item">
                <a className="nav-link fs-5" href="/Gallery">Gallery</a>
              </li>
              <li className="nav-item">
                <a className="nav-link fs-5" href="/Contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className={`mobile-menu position-fixed bg-white shadow-lg p-4 h-100 d-flex flex-column`}
        style={{
          top: 0,
          left: menuOpen ? 0 : "-250px",
          width: "250px",
          transition: "left 0.3s ease-in-out",
          zIndex: 1050
        }}>

        <div className="d-flex align-items-center justify-content-between mb-3">
          <span className="brand-wordmark">
            <span className="brand-name">Devi Vinayaka</span>
            <span className="brand-subtitle">Builders</span>
          </span>
          <button
            className="border-0 bg-transparent fs-3"
            onClick={() => setMenuOpen(false)}
            style={{
              cursor: "pointer",
              fontSize: "32px",
              fontWeight: "bold",
              padding: "5px",
              lineHeight: "1"
            }}
          >
            &times;
          </button>
        </div>

        {/* Underline Separator */}
        <hr style={{ borderTop: "2px solid #ddd" }} />

        {/* Menu Options */}
        <ul className="list-unstyled flex-grow-1">
          <li className="my-2 text-start">
            <a className="fs-5 text-dark text-decoration-none d-block py-2" href="/">Home</a>
          </li>
          <li className="my-2 text-start">
            <a className="fs-5 text-dark text-decoration-none d-block py-2" href="/About">About</a>
          </li>
          <li className="my-2 text-start">
            <div>
              <button
                className="fs-5 text-dark text-decoration-none d-flex align-items-center justify-content-between w-100 border-0 bg-transparent py-2"
                onClick={() => setMobileProjectsDropdownOpen(!mobileProjectsDropdownOpen)}
                style={{ cursor: "pointer" }}
              >
                <span>Projects</span>
                <span style={{ transform: mobileProjectsDropdownOpen ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.2s" }}>
                  &#9660;
                </span>
              </button>
              {mobileProjectsDropdownOpen && (
                <ul className="list-unstyled ms-3 mt-2 border-start ps-3" style={{ borderColor: "#ddd" }}>
                  <li className="my-2">
                    <a className="fs-6 text-dark text-decoration-none d-block py-1" href="/CompletedProjects">
                      <i className="fas fa-check-circle me-2" style={{ color: "#28a745", fontSize: "0.85rem" }}></i>
                      Completed Projects
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </li>
          <li className="my-2 text-start">
            <a className="fs-5 text-dark text-decoration-none d-block py-2" href="/Gallery">Gallery</a>
          </li>
          <li className="my-2 text-start">
            <a className="fs-5 text-dark text-decoration-none d-block py-2" href="/Contact">Contact</a>
          </li>
        </ul>
      </div>
    </header>
  );
};
export default Navbar;
